import { ParagraphStyle } from "@components/Typography/TextStyles/Paragraph"
import { ParagraphSStyle } from "@components/Typography/TextStyles/ParagraphS"
import { breakpoints } from "@config/theme"
import styled from "styled-components"

export const Label = styled.div`
  ${ParagraphStyle};
  width: 100%;
  z-index: 1;
`

export const Sublabel = styled.span`
  ${ParagraphSStyle};
  display: block;
  color: ${(p) => p.theme.colors.text.light};
  line-height: 1;
  z-index: 1;
`

export const Row = styled.div`
  margin-bottom: 0.5rem;
  position: relative;

  @media screen and (min-width: ${breakpoints.small}) {
    align-items: flex-start;
    display: grid;
    grid-template-columns: 10rem auto;
  }
`
